// Janela de conteúdo que abre por cima da área do jogo, com a moldura de diálogo do cliente.
import type { ComponentChildren } from 'preact';

export function ContentWindow(props: { title: string; icon?: string; onClose: () => void; children: ComponentChildren }) {
  return (
    <div class="cw-backdrop" onClick={(e) => { if (e.target === e.currentTarget) props.onClose(); }}>
      <div class="tb-window cw" role="dialog" aria-label={props.title}>
        <div class="tb-window-title">{props.title}</div>
        <button class="cw-close" title="Fechar" onClick={props.onClose} />
        <div class="tb-window-body">{props.children}</div>
      </div>
    </div>
  );
}
